import moment from 'moment';

import { ApiService } from '../../app-lite/api/api.service';
import { CodeTypeModel } from '../../app-lite/core/models/code-type';
import { TableService }  from '../../app-lite/table/table.service';

import EventHtml            from './event.html';
import EventItemsHtml       from './event.items.html';
import EventsHtml           from './events.html';
import EventsOpenHtml       from './events.open.html';
import EventsUnassignedHtml from './events.unassigned.html';

export function EventsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'eventListCtrl',
    name       : 'app.events',
    templateUrl: EventsHtml,
    url        : '/events/:date',
    resolve    : {
      events   : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/events', [$stateParams.date, 0, 5, 'description', 'desc']),
      chartData: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const date = moment($stateParams.date);

        return workshopAPI.get('events/events_by_date', [ (date.month() + 1), date.date(), date.year(), 1 ]);
      }
    }
  })
  .state({
    controller : 'eventItemsListCtrl',
    name       : 'app.event-items',
    templateUrl: EventItemsHtml,
    url        : '/event_items/:id/:date',
    resolve    : {
      events  : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/event_items/mechanic_event_items', [$stateParams.id, $stateParams.date]),
      mechanic: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string => $stateParams.id !== 'unassigned'
        ? workshopAPI.get('/mechanic', $stateParams.id)
        : ''
    }
  })
  .state({
    controller: 'eventCtrl',
    name      : 'app.event',
    params    : {
      customer_id: { squash: true, value: null },
      id         : { squash: true, value: null },
      vehicle_id : { squash: true, value: null }
    },
    reloadOnSearch: false,
    templateUrl   : EventHtml,
    url           : '/:customer_id/:vehicle_id/event/:id?event_item_id&unassigned_event_time_id&date',
    resolve       : {
      defaultLaborItem: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/products/default_labor_item'),
      taxGroups       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/tax_groups'),
      customer        : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.customer_id
          ? workshopAPI.get('/customer', $stateParams.customer_id)
          : '',
      defaultTaxGroup: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> =>
        $stateParams.customer_id
          ? workshopAPI.get('/tax_groups/default_for_customer', $stateParams.customer_id)
          : null,
      event: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/event', $stateParams.id)
          : '',
      inspections: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/event/inspection_list', $stateParams.id)
          : [],
      invoices: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/events/invoices_for_event_list', [ $stateParams.id, 0, 5, 'post_date', 'desc' ])
          : [],
      jobStatusTypes: ( workshopAPI : ApiService ) : ng.IPromise<Array<CodeTypeModel>> => workshopAPI.get('/system/job_status_types'),
      vehicle       : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.vehicle_id
          ? workshopAPI.get('/vehicle', $stateParams.vehicle_id)
          : ''
    }
  })
  .state({
    controller : 'UnassignedEventsCtrl',
    name       : 'app.unassigned-events',
    templateUrl: EventsUnassignedHtml,
    url        : '/unassigned_bookings',
    resolve    : {
      bookings: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('unassignedBookings');

        return workshopAPI.get('/dashboard/unassigned_bookings_list', [
          cache.paging.pageSize   || 10,
          0,
          cache.sorting.field     || 'event_date',
          cache.sorting.direction || 'asc'
        ]);
      }
    }
  })
  .state({
    controller : 'OpenEventsCtrl',
    name       : 'app.open-events',
    templateUrl: EventsOpenHtml,
    url        : '/open_bookings',
    resolve    : {
      bookings: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('openBookings');

        return workshopAPI.get('/dashboard/open_bookings_list', [
          cache.paging.pageSize   || 10,
          0,
          cache.sorting.field     || 'event_date',
          cache.sorting.direction || 'asc'
        ]);
      }
    }
  });
}